export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 flex items-center justify-center rounded-2xl bg-primary-500">
            <i className="ri-smartphone-line text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              红桃影院APP - 随时随地追剧不等待
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              支持 iOS 与 Android 双平台，流畅播放、离线缓存、个性化推荐，
              让最新电视剧和热播剧集尽在掌握。下载APP还可享受免广告追剧特权。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-100 text-sm text-foreground-700">
                <i className="ri-apple-line"></i> iOS版
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-100 text-sm text-foreground-700">
                <i className="ri-android-line"></i> Android版
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-100 text-sm text-foreground-700">
                <i className="ri-computer-line"></i> 网页版
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}